(()=>{const swap=s=>typeof s==='string'?s.replace(/VIRELTO/g,'ZHOPU').replace(/Virelto/g,'Zhopu'):s;const apply=root=>{if(!root)return;const walker=document.createTreeWalker(root,NodeFilter.SHOW_TEXT,{acceptNode:n=>{const p=n.parentElement;if(!p||['SCRIPT','STYLE','NOSCRIPT','TEXTAREA'].includes(p.tagName))return NodeFilter.FILTER_REJECT;return /Virelto|VIRELTO/.test(n.nodeValue||'')?NodeFilter.FILTER_ACCEPT:NodeFilter.FILTER_REJECT;}});const nodes=[];while(walker.nextNode())nodes.push(walker.currentNode);nodes.forEach(n=>{n.nodeValue=swap(n.nodeValue)});root.querySelectorAll?.('[aria-label],[alt],[title],[placeholder]').forEach(el=>['aria-label','alt','title','placeholder'].forEach(a=>{if(el.hasAttribute(a)){const v=el.getAttribute(a);if(/Virelto|VIRELTO/.test(v||''))el.setAttribute(a,swap(v));}}));document.title=swap(document.title);document.querySelectorAll('meta[name="description"],meta[property="og:title"],meta[property="og:description"],meta[name="twitter:title"],meta[name="twitter:description"]').forEach(m=>{const v=m.getAttribute('content');if(/Virelto|VIRELTO/.test(v||''))m.setAttribute('content',swap(v));});};const init=()=>apply(document.body);if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init,{once:true});else init();document.addEventListener('shopify:section:load',e=>apply(e.target));})();

(()=> {
  const handle = 'proyector-galaxia-360-luz-nocturna';

  const setup = () => {
    const section = document.querySelector('[data-virelto-product][data-product-handle="' + handle + '"]');
    if (!section || section.dataset.projectorGalleryFix === 'true') return;
    section.dataset.projectorGalleryFix = 'true';

    const select = section.querySelector('[data-product-variant-select]');
    const thumbs = [...section.querySelectorAll('[data-gallery-thumb]')];
    const count = section.querySelector('[data-gallery-count]');
    const prev = section.querySelector('[data-gallery-prev]');
    const next = section.querySelector('[data-gallery-next]');

    const refresh = () => {
      thumbs.forEach(thumb => { thumb.hidden = false; });
      if (prev) prev.hidden = thumbs.length <= 1;
      if (next) next.hidden = thumbs.length <= 1;

      const option = select ? select.options[select.selectedIndex] : null;
      const imageId = option ? option.dataset.imageId || '' : '';
      const target = imageId
        ? thumbs.find(thumb => String(thumb.dataset.imageId) === String(imageId))
        : null;

      if (target) target.click();

      if (count) {
        const activeIndex = Math.max(0, thumbs.findIndex(thumb => thumb.classList.contains('is-active')));
        count.textContent = String(activeIndex + 1) + ' / ' + String(Math.max(thumbs.length, 1));
      }
    };

    if (select) {
      select.addEventListener('change', () => {
        requestAnimationFrame(() => requestAnimationFrame(refresh));
      });
    }

    requestAnimationFrame(() => requestAnimationFrame(refresh));
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setup, { once: true });
  } else {
    setup();
  }

  document.addEventListener('shopify:section:load', setup);
})();